export default __webpack_public_path__ + "static/media/nfl.b1bc36c0.svg";